"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _LoaderWithMessageModule = _interopRequireDefault(require("./LoaderWithMessage.module.scss"));

var _PulseLoader = _interopRequireDefault(require("./PulseLoader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoaderWithMessage = function LoaderWithMessage(props) {
  if (!props.loading) return null;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_PulseLoader["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: _LoaderWithMessageModule["default"].message
  }, "Wait a moment please..."));
};

var _default = LoaderWithMessage;
exports["default"] = _default;